
import React from 'react';
import { Tag, Gift, CalendarClock } from 'lucide-react';
import TranslatedText from '@/TranslatedText';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';

const PromotionHero: React.FC = () => {
  return (
    <div className="bg-gradient-to-r from-red-600 to-red-800 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        <div className="md:flex md:items-center md:justify-between">
          <div className="md:w-1/2">
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4">
              <TranslatedText text="Special Deals & Promotions" />
            </h1>
            <p className="text-lg md:text-xl mb-6 text-red-100 max-w-xl">
              <TranslatedText 
                text="Discover incredible savings, limited-time offers, and exclusive promotions across our entire range of products."
              />
            </p>
            <div className="flex flex-wrap gap-4">
              <Button size="lg" className="bg-white hover:bg-gray-100 text-red-600">
                <TranslatedText text="View Hot Deals" />
              </Button>
              <Button size="lg" variant="outline" className="border-white text-white hover:bg-white/10">
                <TranslatedText text="Get Coupons" />
              </Button>
            </div>
          </div>
          <div className="mt-8 md:mt-0 md:w-1/2 grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="bg-white/10 backdrop-blur-sm p-4 rounded-lg border border-white/20 flex items-start">
              <Tag size={36} className="text-white mr-3 flex-shrink-0" />
              <div>
                <h3 className="font-semibold text-lg mb-1">
                  <TranslatedText text="Seasonal Discounts" />
                </h3>
                <p className="text-red-100">
                  <TranslatedText text="Up to 50% off on seasonal items" />
                </p>
              </div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm p-4 rounded-lg border border-white/20 flex items-start">
              <Gift size={36} className="text-white mr-3 flex-shrink-0" />
              <div>
                <h3 className="font-semibold text-lg mb-1">
                  <TranslatedText text="Special Coupons" />
                </h3>
                <p className="text-red-100">
                  <TranslatedText text="Exclusive coupons for extra savings" />
                </p>
              </div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm p-4 rounded-lg border border-white/20 flex items-start md:col-span-2">
              <CalendarClock size={36} className="text-white mr-3 flex-shrink-0" />
              <div>
                <h3 className="font-semibold text-lg mb-1">
                  <TranslatedText text="Limited Time Offers" />
                </h3>
                <p className="text-red-100">
                  <TranslatedText text="Flash deals and time-limited promotions updated daily" />
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PromotionHero;
